import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import OwButton from "../OwButton/OwButton";

type NameProps = {
    isOpen: boolean;
    translate: (id: string) => string;
    onSave: (name: string) => void;
    onCancel: () => void;
};

/**
 * Name entry for "Save as New Preset".
 */
export const PresetNameModal = (props: NameProps) => {
    const [name, setName] = useState("");

    useEffect(() => {
        if (props.isOpen) {
            setName("");
        }
    }, [props.isOpen]);

    const save = () => {
        if (name.trim().length) {
            props.onSave(name);
        }
    };

    return (
        <Modal
            isOpen={props.isOpen}
            onRequestClose={props.onCancel}
            className={"modalContentClass FilterBar-modal"}
            overlayClassName={"modalOverlayClass FilterBar-modal-overlay"}
            ariaHideApp={false}
            contentLabel={props.translate("save_as_new_preset")}>
            <div className={"p-3"}>
                <h5 className={"mb-3"}>{props.translate("save_as_new_preset")}</h5>
                <label htmlFor={"filter-preset-name"} className={"form-label"}>
                    {props.translate("preset_name")}
                </label>
                <input
                    id={"filter-preset-name"}
                    className={"form-control form-control-sm"}
                    autoFocus={true}
                    value={name}
                    maxLength={60}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                    onKeyDown={(e: React.KeyboardEvent) => {
                        if (e.key === "Enter") {
                            save();
                        }
                    }}
                />
                <div className={"d-flex justify-content-end mt-3"}>
                    <OwButton title={"cancel"} className={"btn-secondary me-2"} fn={props.onCancel} />
                    <OwButton title={"save"} className={"btn-warning"} fn={save} disabled={!name.trim().length} />
                </div>
            </div>
        </Modal>
    );
};

type ConfirmProps = {
    isOpen: boolean;
    presetName?: string;
    translate: (id: string) => string;
    onConfirm: () => void;
    onCancel: () => void;
};

/**
 * Confirmation before deleting a preset.
 */
export const PresetDeleteConfirm = (props: ConfirmProps) => {
    return (
        <Modal
            isOpen={props.isOpen}
            onRequestClose={props.onCancel}
            className={"modalContentClass FilterBar-modal"}
            overlayClassName={"modalOverlayClass FilterBar-modal-overlay"}
            ariaHideApp={false}
            contentLabel={props.translate("delete_preset")}>
            <div className={"p-3"}>
                <h5 className={"mb-2"}>{props.translate("delete_preset")}</h5>
                <p className={"mb-3"}>
                    {props.translate("confirm_delete")}
                    {props.presetName ? <strong className={"ms-1"}>{props.presetName}</strong> : null}
                </p>
                <div className={"d-flex justify-content-end"}>
                    <OwButton title={"cancel"} className={"btn-secondary me-2"} fn={props.onCancel} />
                    <OwButton title={"delete"} className={"btn-danger"} fn={props.onConfirm} />
                </div>
            </div>
        </Modal>
    );
};
